import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'dtrax-route-change-confirmation',
  templateUrl: './route-change-confirmation.component.html',
  styleUrls: ['./route-change-confirmation.component.scss']
})
export class RouteChangeConfirmationComponent {

  constructor(
    public dialogRef: MatDialogRef<RouteChangeConfirmationComponent>,
  ) {
  }
}
